import React from 'react'
import './Order.css'
import moment from "moment"
import CheckoutProduct from './CheckoutProduct'
import { NumericFormat } from "react-number-format";

function Order({order}) {
    return (
        <div className="order">
            <h2>Order</h2>
            <p className='order__id'>
                <small>order id : {order.id}</small>
            </p>
            <p >Status : {order.data.status?order.data.status:'Pending'}</p>
            <p>{moment.unix(order.data.created).format('MMMM Do YYYY, h:mma')}</p>
            {order.data.basket?.map((item,i)=>(
                <CheckoutProduct key={i}
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                count={item.count}
                hideButton
                />
            ))}
            <NumericFormat
            renderText={(value)=>(
            <h3 className='order__total'>Order Total : {value}</h3>
            )}
            decimalScale={2}
            value={order.data.amount/100}
            displayType={"text"}
            thousandSeparator
            prefix={"₹"}
            />
        </div>
    )
}

export default Order
